import { defineComponent, computed, h, provide } from 'vue';
import '../../theme-chalk/src/row.scss';

export default defineComponent({
    name: 'PtRow',
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        gutter: {
            type: Number,
            default: 0,
        },
        justify: {
            type: String,
            default: 'start',
        },
        align: {
            type: String,
            default: 'top',
        },
    },
    setup(props, { slots }) {
        const gutter = computed(() => props.gutter);
        provide('PtRow', {
            gutter,
        });

        const style = computed(() => {
            const ret = {
                marginLeft: '',
                marginRight: '',
            };
            if (props.gutter) {
                ret.marginLeft = `-${props.gutter / 2}px`;
                ret.marginRight = ret.marginLeft;
            }
            return ret;
        });

        return () =>
            h(
                props.tag,
                {
                    class: [
                        'pt-row',
                        props.justify !== 'start' ? `is-justify-${props.justify}` : '',
                        props.align !== 'top' ? `is-align-${props.align}` : '',
                    ],
                    style: style.value,
                },
                slots.default?.(),
            );
    },
});
